export default __webpack_public_path__ + "static/media/logo-dark.06cdfb84.png";